import { useEffect, useState, useContext } from 'react';
import cx from 'classnames';

import useRequest from 'core/hooks/useRequest';
import { bebop as bebopApi } from 'core/api/definitions/bebop';

import { denormalizeData } from 'core/utils/api';
import resolveRelationships from 'core/utils/relationships';

import Link from 'core/components/Link';
import SmartImage from 'core/components/SmartImage';
import { GlobalTopicContext } from 'core/components/GlobalTopicProvider';
import RequestIdContext from 'core/components/App/requestId';

import styles from './index.styl';


const getRandomFromArr = (arr) => {
  if (!arr || arr.length === 0) return null;
  return arr?.[Math.floor(Math.random() * arr.length)];
};

const relationships = resolveRelationships(['image'], {}, {
  image: {
    versions: {},
  },
});


function SelfPromo() {
  const topic = useContext(GlobalTopicContext);
  const requestId = useContext(RequestIdContext);

  const { data, isLoading } = useRequest({
    queryKey: ['bebopApi', 'getTopics', {
      include: 'image',
      fields: 'link',
      list: 'selfpromo',
    }],
    queryFn: ({ queryKey: [, method, params] }) => bebopApi[method](params).catch(() => null),
    select: denormalizeData,
    enabled: process.env.BROWSER_RUNTIME,
  });

  const topicId = topic?.id;
  const [randomTopic, setRandomTopic] = useState(null);

  useEffect(() => {
    if (data) {
      setRandomTopic(getRandomFromArr(data.filter(item => item.id !== topicId)));
    }
  }, [data, requestId, topicId]);

  if (isLoading || !process.env.BROWSER_RUNTIME) return <div className={cx(styles.loader, 'lb-skeleton')} />;
  if (!randomTopic?.attributes) return null;

  const {
    link,
  } = randomTopic.attributes;

  const {
    image: {
      versions,
      caption,
    },
  } = relationships(randomTopic);

  return (
    <Link to={link}>
      <SmartImage
        alt={caption}
        version='selfpromo'
        versions={versions}
        aspectRatio={1}
        width={300}
      />
    </Link>
  );
}

export { SelfPromo as StorybookComponent };
export default SelfPromo;
